import { apiClient } from './client';
import type { ProductFeatureDefinition } from './admin';

export interface SubscriptionPlan {
  id: number;
  product?: {
    code: string;
    name: string;
  } | null;
  code: string;
  name: string;
  description?: string | null;
  amount: number;
  currency: string;
  intervalUnit: string;
  intervalCount: number;
  razorpayPlanId?: string | null;
  status: string;
  isDefault: boolean;
  isPublic: boolean;
  isPopular: boolean;
  showOnLanding: boolean;
  billingType: 'free' | 'recurring';
  features: Record<string, unknown>;
}

export interface AdminSubscriptionsOverview {
  products: Array<{
    id: number;
    code: string;
    name: string;
    description?: string | null;
    featureSchema: ProductFeatureDefinition[];
    status: string;
  }>;
  selectedProductCode?: string | null;
  summary: {
    total: number;
    active: number;
    pending: number;
    halted: number;
    cancelled: number;
  };
  plans: SubscriptionPlan[];
  subscriptions: Array<{
    id: number;
    email: string;
    name?: string | null;
    product?: {
      code: string;
      name: string;
    } | null;
    status: string;
    providerSubscriptionId: string;
    currentStart?: string | null;
    currentEnd?: string | null;
    cancelAtCycleEnd: boolean;
    checkoutLink?: string | null;
    createdAt: string;
    plan: SubscriptionPlan | null;
  }>;
  recentEvents: Array<{
    id: number;
    provider: string;
    event_type: string;
    provider_subscription_id?: string | null;
    processed_at: string;
    product?: {
      code: string;
      name: string;
    } | null;
  }>;
}

export const getAdminSubscriptionsOverview = (productCode?: string) =>
  apiClient.get<{ success: true; data: AdminSubscriptionsOverview }>('/api/admin/subscriptions/overview', {
    params: productCode ? { productCode } : undefined,
  });

export const createAdminSubscriptionPlan = (
  payload: {
    productCode?: string;
    code: string;
    name: string;
    description?: string;
    amount: number;
    currency?: string;
    intervalUnit: string;
    intervalCount?: number;
    isDefault?: boolean;
    isPublic?: boolean;
    isPopular?: boolean;
    showOnLanding?: boolean;
    features?: SubscriptionPlan['features'];
  },
) =>
  apiClient.post('/api/admin/subscriptions/plans', payload);
